import React from 'react'
import { observer } from 'mobx-react-lite'
import StoryList from 'components/StoryList'
import Sidebar from 'components/Sidebar'
import { THEME } from 'utils'

const PlaylistsIndex = ({ items, next, hasMore, title, page, adSettings }) => {
  return (
    <>
      <div className='container'>
        <div className='row row--main'>
          <div className='col col--main'>
            <div className='stories-container'>
              {title && <h1 className='stories__title'>{title}</h1>}
              <StoryList items={items} next={next} hasMore={hasMore} feedType='playlists' />
            </div>
          </div>
          <div className='col col--sidebar'>
            <Sidebar adSettings={adSettings} page={page} />
          </div>
        </div>
      </div>
      <style jsx>{`
        .container > .row {
          display: grid;
          grid-template-columns: 1fr 300px;
          grid-column-gap: 30px;
          margin-left: 0;
          margin-right: 0;
        }
        .container > .row > .col {
          padding: 0;
        }
        @media (max-width: ${THEME.BREAKPOINTS.SM - 1}px) {
          .container > .row {
            grid-template-columns: 1fr;
          }
        }
        .container {
          padding-left: 0;
          padding-right: 0;
        }
        @media (min-width: 480px) {
          .container {
            padding-left: 15px;
            padding-right: 15px;
          }
        }
        .stories-container {
          background-color: white;
          padding: 0;
          box-shadow: ${THEME.BOX_SHADOW.DEFAULT};
        }
        .stories__title {
          font-family: ${THEME.FONTS.BEBAS};
          font-size: 1.875rem;
          font-weight: 600;
          text-transform: uppercase;
          color: ${THEME.COLORS.SECONDARY};
          line-height: 1.2;
          padding: 0.75rem 1.125rem;
          margin: 0;
        }
      `}</style>
    </>
  )
}

export default observer(PlaylistsIndex)
